import { createAction } from "redux-actions";
import { GET_QUESTIONS } from "../constants";
import { serverGetAllData } from "../services/crud";

export const getQuestions = createAction(GET_QUESTIONS, () => serverGetAllData('questions')())